<template>
  <div>
    <Header
      class="yh-header"
      active="/product"
      :product-value="productValue"
    />
    <div style="height: 70px" />
    <el-container class="container">
      <el-aside
        width="240px"
      >
        <VerticalSelect
          v-if="firmId"
          :active="firmId.toString()"
          :type="'product'"
          @selected="onFirmCode"
        />
        <ProductCategoryVerticalSelect
          v-else
          :active="categoryCode"
          :type="'product'"
          @selected="onCategoryCode"
        />
      </el-aside>
      <el-main>
        <el-tag
          v-if="brand"
          closable
          class="tag"
          @close="handleClose"
        >
          {{ brand }}
        </el-tag>
        <ProductBasePage
          @change="onPageChange"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Header from '@/components/Header'
import ProductCategoryVerticalSelect from '@/components/ProductCategoryVerticalSelect.vue'
import ProductBasePage from '@/components/ProductBasePage.vue'
import VerticalSelect from './ownBrandProduct/Components/VerticalSelect'
export default {
  name: 'ProductHome',
  components: {
    Header,
    ProductCategoryVerticalSelect,
    ProductBasePage,
    VerticalSelect
  },
  data() {
    const type = this.$route.query.type
    return {
      firmId: this.$route.query.firmId, // 商行ID
      brand: {                          // 品牌类型
        yhnc: '永辉农场',
        tq: '田趣',
        cds: '馋大狮',
        ys: '优颂',
        ofresh: 'OFRESH'
      }[type],
      categoryCode: '',
      productValue: this.util.getVariantSession('tagId')
    }
  },
  created() {
    if (this.$route.query.categoryCode) {
      this.categoryCode = this.$route.query.categoryCode
    }
    if (this.firmId) {  // 自由品牌
      this.$store.dispatch('productCategoryPage', {
        packageName: 'product',
        className: 'firm',
        methodName: 'firmCategory',
        method: 'GET'
      })
    } else {
      this.$store.dispatch('productCategoryPage', {
        packageName: 'product',
        className: 'productCategory',
        methodName: 'retrieve',
        params: {
          codeStartWith: '11',
          numPerPage: 1000,
          tag: this.util.getVariantSession('tag')
        }
      })
    }

    this.onPageChange(1)

    this.ajax.doPost({
      packageName: 'user',
      className: 'userAnalysis',
      methodName: 'create',
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: '商品百科-查询',
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    })
  },
  methods: {
    // 商品百科
    onCategoryCode(e) {
      this.categoryCode = e
      this.getProductBase({
        numPerPage: 20,
        categoryCode: e
      })
    },
    // 自由品牌
    onFirmCode(e) {
      this.firmId = e
      this.getProductBase({
        numPerPage: 20,
        tag: this.util.getVariantSession('tag'),
        firmId: this.firmId,
        brand: this.brand
      })
    },
    onPageChange(e) {
      this.getProductBase({
        pageNum: e,
        numPerPage: 20,
        tag: this.util.getVariantSession('tag'),
        categoryCode: this.categoryCode,
        firmId: this.firmId,
        brand: this.brand
      })
    },
    getProductBase(params) {
      this.$store.dispatch('productBasePage', {
        packageName: 'product',
        className: 'productBase',
        methodName: 'retrieve',
        params
      })
    },
    // 移除品牌
    handleClose() {
      this.brand = ''
      this.getProductBase({
        numPerPage: 20,
        tag: this.util.getVariantSession('tag'),
        firmId: this.firmId,
        brand: this.brand
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 20px auto;
  .tag{
    margin: 0 0 10px 10px;
  }
}
.el-breadcrumb {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
</style>
